 document.addEventListener('DOMContentLoaded', () => {
    const categoryTitles = document.querySelectorAll('.category-title');
    const subCategories = document.querySelectorAll('.sub-category-item');
    const sizeChartContent = document.querySelectorAll(".size-chart-container-content");

    if (categoryTitles.length === 0) return;

    // Hide all subcategories initially
    subCategories.forEach(sub => sub.style.display = 'none');

    // --- Activate FIRST CATEGORY + FIRST SUBCATEGORY ---
    const firstCategory = categoryTitles[0];
    const defaultCategory = firstCategory.dataset.category;
    firstCategory.classList.add('active');

    // Show only subcategories belonging to first category
    const matchingSubs = Array.from(subCategories).filter(
        sub => sub.dataset.parent === defaultCategory
    );

    matchingSubs.forEach(sub => (sub.style.display = 'block'));

    // Add active class to only first subcategory in that group
    if (matchingSubs.length > 0) matchingSubs[0].classList.add('active');
    // ---------------------------------------------------

    // --- Handle category switching ---
    categoryTitles.forEach(title => {
        title.addEventListener('click', () => {
            const selectedCategory = title.dataset.category;

            // Reset active states
            categoryTitles.forEach(t => t.classList.remove('active'));
            subCategories.forEach(sub => {
                sub.classList.remove('active');
                sub.style.display = 'none';
            });

            // Activate clicked category
            title.classList.add('active');

            // Show subcategories that match clicked category
            const relatedSubs = Array.from(subCategories).filter(
                sub => sub.dataset.parent === selectedCategory
            );

            relatedSubs.forEach(sub => (sub.style.display = 'block'));

            // Activate first subcategory in that category
            if (relatedSubs.length > 0) relatedSubs[0].classList.add('active');

            const currentActiveCategoryVal = title.getAttribute("data-category");
            const currentActiveSubCategoryVal = document.querySelector(".sub-category-item.active").getAttribute("data-sub-category");
            sizeChartContent.forEach(sizeChart => {
                sizeChart.classList.remove("active");
            })
            sizeChartContent.forEach(sizeChart => {
                const chartCategoriesVal = sizeChart.getAttribute("data-categories");
                if(chartCategoriesVal == `${currentActiveCategoryVal}-${currentActiveSubCategoryVal}`){
                    sizeChart.classList.add("active");
                }
            })
        });
    });
    subCategories.forEach(subCategorie => {
        subCategorie.addEventListener("click", () => {
            subCategories.forEach(element => {
                element.classList.remove("active");
            });
            subCategorie.classList.add("active");

            const currentActiveCategoryVal = document.querySelector(".category-title.active").getAttribute("data-category");
            const currentActiveSubCategoryVal = subCategorie.getAttribute("data-sub-category");
            sizeChartContent.forEach(sizeChart => {
                sizeChart.classList.remove("active");
            });
            sizeChartContent.forEach(sizeChart => {
                const chartCategoriesVal = sizeChart.getAttribute("data-categories");
                if(chartCategoriesVal == `${currentActiveCategoryVal}-${currentActiveSubCategoryVal}`){
                    sizeChart.classList.add("active");
                }
            });
        })
    })
});